import { useRef, useEffect, useState } from 'react';
import CharacterContent from '../components/Character/CharacterContent.jsx';
import { CharacterActionProvider } from '../components/Character/Contexts/CharacterActions.js';
import { CharacterProvider } from '../components/Character/Contexts/CharacterInfo.js';
import { useGeneralContext } from '../components/GeneralContext.js';
import theme from '../theme.js';

const Character = index => {
  const { registerFailRoll, unregisterFailRoll } = useGeneralContext();
  const failRef = useRef(null);
  const callbackRef = useRef(null);
  const [failColor, setFailColor] = useState(theme.colors.red);

  const showFailRoll = () => {
    if (failRef.current) {
      failRef.current.style.animation = 'none';
      void failRef.current.offsetWidth;
      failRef.current.style.animation = `failRoll 450ms ease 2`;
    }
  };

  useEffect(() => {
    callbackRef.current = color => {
      if (color) setFailColor(color);
      showFailRoll();
    };
  }, []);

  useEffect(() => {
    const stableFn = (...args) => {
      callbackRef.current?.(...args);
    };
    registerFailRoll(stableFn);
    return () => unregisterFailRoll(stableFn);
  }, [registerFailRoll, unregisterFailRoll]);

  return (
    <CharacterProvider index={index.index}>
      <CharacterActionProvider>
        <div ref={failRef}>
          <style>
            {`@keyframes failRoll 
            {
              50% {box-shadow: inset 200px 0 200px -200px rgb(from ${failColor} r g b / .7),
              0 0 20px 200px rgb(from ${failColor} r g b / .7),
              inset -200px 0 200px -200px rgb(from ${failColor} r g b / .7);}
            }`}
          </style>
          <CharacterContent />
        </div>
      </CharacterActionProvider>
    </CharacterProvider>
  );
};

export default Character;
